<template>
  <div>
    <base-header class="pb-8 pt-4">
      <b-row class="mb-3">
        <b-col sm="12" md="" class="mt-2">
          <b-card bg-variant="info" text-variant="white" no-body>
            <h3 class="text-white p-3">Toplam {{ sumOfPay }} {{ $t("TL Ara Ödeme Alındı") }}</h3>
          </b-card>
        </b-col>
        <b-col sm="12" md="" class="mt-2">
          <b-card bg-variant="info" text-variant="white" no-body>
            <h3 class="text-white p-3">Toplam {{ subPaysDebt }} {{ $t("TL Ara Ödeme Yapıldı") }}</h3>
          </b-card>
        </b-col>
        <b-col sm="12" md="" class="mt-2">
          <b-card bg-variant="info" text-variant="white" no-body>
            <h3 class="text-white p-3">Toplam {{ sumOfCredit }} {{ $t("TL Alacak Mevcut") }}</h3>
          </b-card>
        </b-col>
        <b-col sm="12" md="" class="mt-2">
          <b-card bg-variant="warning" text-variant="white" no-body>
            <h3 class="text-white p-3">Çek Bakiyesi {{ checkBalance }} TL</h3>
          </b-card>
        </b-col>
        <b-col sm="12" md="" class="mt-2">
          <b-card bg-variant="warning" text-variant="white" no-body>
            <h3 class="text-white p-3">Senet Bakiyesi {{ billBalance }} TL</h3>
          </b-card>
        </b-col>
        <b-col sm="12" md="" class="mt-2">
          <b-card bg-variant="success" text-variant="white" no-body>
            <h3 class="text-white p-3">Toplam Ciro {{ total }} TL</h3>
          </b-card>
        </b-col>


        <b-col sm="12" md="">
          <b-card bg-variant="danger" text-variant="white" no-body>
            <h3 class="text-white p-3">Toplam {{ sumOfDebt }} {{ $t("TL Borç Mevcut") }}</h3>
          </b-card>
        </b-col>
        <b-col>

          <b-card bg-variant="primary" text-variant="white" no-body>
            <h3 class="text-white p-3"> {{ $t("Bu Ay Ödenecek Borç")  }} {{ monthlyDebt }} TL</h3>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
    <div class="container-fluid mt--7" v-if="loading">
      <b-row>
        <b-col class="text-center">
          <b-spinner/>
        </b-col>
      </b-row>
    </div>
    <div class="container-fluid mt--7" v-else>
      <b-row>
        <b-col sm="12" class="text-right mb-3">
          <b-button variant="default" @click="sendSMSModal">{{ $t("SMS Gönder") }}</b-button>
          <b-button variant="primary" @click="getReport" :disabled="loading">{{ loading ? 'Bekleyiniz..' : $t("Detaylı Rapor Al") }}</b-button>
          <b-button variant="primary" v-b-modal.createRecordModal>+ {{ $t("İşlem Oluştur") }}</b-button>
          <b-link :to="{name:'supplier-products'}">
            <b-button variant="primary">{{ $t("Tedarikçi Ürünleri") }}</b-button>
          </b-link>

        </b-col>




      </b-row>
      <b-card class="mb-3" title="Genel Bilgiler">
        <b-table thead-class="d-none" bordered :fields="[{key: 'text'},{key: 'value'}]" :items="generalInfo" responsive>
          <template v-slot:thead-top="data">
            <b-tr></b-tr>
          </template>

          <template v-slot:cell(text)="data">
            <b>{{ data.item.text }}</b>
          </template>
        </b-table>
      </b-card>
      <b-card class="mb-3" title="Banka Hesapları">
        <p v-for="(account, key) in bankAccounts" :key="key">
          <b>{{ account.text }}</b>
        <ul>
          <li><b>Hesap Adı:</b> {{ account.account_name }}<br></li>
          <li><b>Şube Adı:</b> {{ account.branch_name }}<br></li>
          <li><b>Şube Kodu:</b> {{ account.branch_code }}<br></li>
          <li><b>Hesap No:</b> {{ account.account_number }}<br></li>
          <li><b>Döviz:</b> {{ account.currency }}<br></li>
          <li><b>Iban:</b> {{ account.iban }}</li>
        </ul>
        </p>
      </b-card>

      <b-card :title="`Ödeme Hareketleri (${type.text})`" v-for="type in types" :key="type.type" class="mb-4">
        <b-table
            ref="table"
            class="align-items-center"
            thead-class="thead-light"
            :fields="accountingFields"
            :items="history.filter(h=>h.type==type.type)"
            style="height: 300px" responsive>

          <template v-slot:cell(title)="data">
            {{ data.item.title }}
            <b-badge variant="success" v-if="data.item.type === 'income'">{{ $t("GELİR") }}</b-badge>
            <b-badge variant="danger" v-else-if="data.item.type === 'expense'">{{ $t("GİDER") }}</b-badge>
            <b-badge variant="info" v-else-if="data.item.type === 'credit'">{{ $t("ALACAK") }}</b-badge>
            <b-badge variant="warning" v-else>BORÇ</b-badge>
          </template>

          <template v-slot:cell(payment_type)="data">
            {{ paymentType(data.item.payment_type) }}
          </template>

          <template v-slot:cell(last_payment_date)="data">
            {{ moment(data.item.last_payment_date).format('L') || 'Belirtilmemiş' }}
          </template>
          <template v-slot:cell(date)="data">
            {{ data.item.date && moment(data.item.date).format('L') }}
          </template>

          <template v-slot:cell(actions)="data">
<!--            <b-button variant="warning" size="sm" @click="showAccounting(data.item)">{{-->
<!--                $t("Görüntüle")-->
<!--              }}-->
<!--            </b-button>-->
            <b-button variant="danger" size="sm" @click="deleteAccountingAction(data.item.id)">{{
                $t("Sil")
              }}
            </b-button>
          </template>
        </b-table>
      </b-card>

    </div>

    <b-modal ref="sendSMSModal" title="SMS Gönder">
      <b-form-group>
        <label>Mesaj</label>
        <b-form-textarea v-model="smsText"/>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.sendSMSModal.hide()">{{ $t("İptal") }}</b-button>
        <b-button variant="primary" @click="sendSMS">{{ $t("Gönder") }}</b-button>
      </template>
    </b-modal>

    <b-modal ref="accountingModal" title="İşlem Detayları">
      <b-table-simple v-if="accounting.services && accounting.services.length==0">
        <b-tr>
          <b-td>Kategori</b-td>
          <b-td>Açıklama</b-td>
          <b-td>Toplam Tutar</b-td>
          <b-td>Tarih</b-td>
        </b-tr>
        <b-tr>
          <b-td>{{ accounting.category.hasOwnProperty('name') ? accounting.category.name : '' }}</b-td>
          <b-td>{{ accounting.description }}</b-td>
          <b-td>{{ accounting.price }} TL</b-td>
          <b-td>
            {{ moment(accounting.created_at).format('L') || 'Belirtilmemiş' }}
          </b-td>
        </b-tr>
      </b-table-simple>
      <b-table v-if="accounting.services && accounting.services.length>0" :fields="[
        { key: 'service.name', label: 'Başlık', },
        { key: 'piece', label: 'Adet', },
        { key: 'price', label: 'Fiyat', },
        { key: 'discount', label: 'İndirim', },
        { key: 'tax', label: 'KDV Oranı', },
      ]" :items="accounting.services" bordered/>
      <template v-slot:modal-footer>
        <b-button @click="$refs.accountingModal.hide()" variant="secondary">{{ $t("Kapat") }}</b-button>
      </template>
    </b-modal>

    <b-modal ref="createRecordModal" id="createRecordModal" title="Kayıt Oluştur" @hide="resetRecordModal" size="xl"
             hide-footer>
      <b-form-radio-group
          v-model="record.type"
          :options="[
          { text: 'Alacak', value: 'credit' },
          { text: 'Borç', value: 'debt' },
          { text: 'Ara Ödeme (Al)', value: 'pay' },
          { text: 'Ara Ödeme (Yap)', value: 'payDebt' },
        ]"
          name="radios-btn-default"
          button-variant="outline-primary"
          style="cursor:pointer;"
          buttons/>

      <create-credit
          v-if="record.type === 'credit'"
          :client-id="$route.params.id"
          @close="$refs.createRecordModal.hide()"
          type="credit"
          @success="loadPage"/>
      <create-credit
          v-else-if="record.type === 'debt'"
          :show="true"
          type="debt"
          :client-id="$route.params.id"
          @hide="$refs.createRecordModal.hide()"
          @refresh-table="loadPage"/>
      <pay
          v-else-if="record.type === 'pay'"
          :history="history.filter(hist=>hist.type=='credit')"
          type="income"
          :show="true"
          :client-id="$route.params.id"
          @hide="$refs.createRecordModal.hide()"
          @refresh-table="loadPage"/>
      <pay
          v-else-if="record.type === 'payDebt'"
          :history="history.filter(hist=>hist.type=='debt')"
          type="expense"
          :show="true"
          :client-id="$route.params.id"
          @hide="$refs.createRecordModal.hide()"
          @refresh-table="loadPage"/>

    </b-modal>
    <b-modal ref="createRecordModal" id="createPayModal" title="Ara Ödeme Oluştur" @hide="resetRecordModal" size="xl"
             hide-footer>
      <pay
          :history="history"
          :show="true"
          :client-id="$route.params.id"
          @hide="$refs.createRecordModal.hide()"
          @refresh-table="loadPage"/>

    </b-modal>
    <b-modal size="xl" ref="imageModal" title="Resim" hide-footer>
      <img :src="selectedImage.image" class="img-fluid" alt="">
    </b-modal>

    <b-modal size="lg" title="Sipariş Sözleşmesi" ref="contractModal">
      <ckeditor v-model="selectedContract" editor-url="https://cdn.ckeditor.com/4.16.2/full/ckeditor.js"
                :config="config"/>

      <template #modal-footer>
        <div class="w-100">

          <b-button @click="saveOrderContract" size="md" variant="primary">{{ $t("Kaydet") }}</b-button>
          <b-button
              variant="light"
              size="md"
              class="float-right"
              @click="this.$refs.contractModal.hide()"
          >
            {{ $t("Kapat") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CreateCredit from "../suppliers/CreateCredit";
import DebtModal from '../../components/modal/Debt';
import Pay from "./Pay";
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment'
import request from "../../request";

export default {
  components: {CreateCredit, DebtModal, Pay},
  data() {
    return {
      moment: moment,
      types:[
        {
          text:"Gelir",
          type:"income"
        },
        {
          text:"Gider",
          type:"expense"
        },
        {
          text:"Borç",
          type:"debt"
        },
        {
          text:"Alacak",
          type:"credit"
        },
      ],
      config: {
        language: 'tr',
        height: 400,
        toolbarGroups: [
          {name: 'document', groups: ['mode', 'document', 'doctools']},
          {name: 'clipboard', groups: ['clipboard', 'undo']},
          {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
          {name: 'forms', groups: ['forms']},
          {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
          {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
          {name: 'links', groups: ['links']},
          {name: 'insert', groups: ['insert']},
          {name: 'styles', groups: ['styles']},
          {name: 'colors', groups: ['colors']},
          {name: 'tools', groups: ['tools']},
          {name: 'others', groups: ['others']},
          {name: 'about', groups: ['about']}
        ],
        removeButtons: 'Save,NewPage,ExportPdf,Preview,Print,Templates,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,PasteFromWord,CreateDiv,Language,Image,Flash,Iframe,About,ShowBlocks',
      },
      selectedContract: {},
      selectedContractId: null,
      selectedImage: '',
      newImage: null,
      loading: false,
      record: {
        type: 'credit',
      },
      expenseCategories: [],
      incomeCategories: [],
      sumOfCredit: 0,
      sumOfPay: 0,
      subPaysDebt: 0,
      sumOfDebt: 0,
      checkBalance: 0,
      billBalance: 0,
      total: 0,
      smsText: '',
      accounting: {},
      clientImages: [],
      generalInfo: [
        {text: 'Ad Soyad', value: ''},
        {text: 'Telefon', value: ''},
        {text: 'E-mail', value: ''},
        {text: 'Firma Adı (Ünvan)', value: ''},
        // { text: 'Web Sitesi', value: '' },
        {text: 'Vergi Dairesi / No', value: ''},
        // { text: 'Bakiye', value: '' },
        // {text: 'Kimlik No', value: ''},
      ],
      contractsFields: [
        {key: 'title', label: 'Başlık'},
        {key: 'services', label: 'Ürünler'},
        {key: 'created_at', label: 'Oluşturulma Tarihi'},
        {key: 'actions', label: ''},
      ],
      contracts: [],
      bankAccounts: [],
      accountingFields: [
        {key: 'title', label: 'Başlık'},
        {key: 'price', label: 'Ücret'},
        {key: 'date', label: 'Ödendiği Tarih'},
        {key: 'last_payment_date', label: 'Son Ödeme Tarihi'},
        {key: 'payment_type', label: 'Ödeme Şekli'},
        {key: 'actions', label: '', tdClass: 'text-right'}
      ],
      history: [],
      appointments: [],
    }
  },
  methods: {
    ...mapActions(['showClientDetails', 'getIncomeDependencies', 'saveOrderContractById', 'sendSMSToClient', 'deleteAccounting', 'deleteOrderContract', 'uploadImage', 'deleteImage', 'getOrderContractById', 'getUser', 'toPdf']),

    getReport(){
      this.loading=true
      request.get('getsupplierreport/'+this.$route.params.id).then(res=>{
        location.href=res.data.url
      }).catch(err=>{
        this.error(err.response.message)
      }).finally(()=>this.loading=false)
    },
    saveOrderContract() {
      this.saveOrderContractById({
        id: this.selectedContractId,
        contract: this.selectedContract
      }).then(res => {
        this.$refs.contractModal.hide()
        this.success('Sözleşme Başarıyla Kaydedildi!')
      })
    },
    openImage(image) {
      this.selectedImage = image
      this.$refs.imageModal.show()
    },
    delImage(id) {
      this.deleteImage({id: id}).then(res => {
        this.success('BAŞARILI')
        this.clientImages = res.data.images
      }).catch(err => this.error('HATA'))
    },
    changeImage(e) {
      const formData = new FormData()
      formData.append('image', e.target.files[0])
      formData.append('client_id', this.client.id)
      this.uploadImage(formData).then(res => {
        this.clientImages = res.data.images


        this.success('Başarılı!')

      }).catch(err => this.error(err.response.message))
    },
    deleteOrderAction(id) {

      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'İşlem kalıcı olarak silinecektir, emin misiniz?',
      }).then(ok => {
        if (ok.value) {

          this.deleteOrderContract(id).then(res => {
            this.success(res.data.message);
            this.loadPage()
          }).catch(err => {
            this.error(err.response.data.message)
          })
        }
      });
    },
    loadPage() {
      this.$refs.accountingModal.hide();
      this.loadData();
    },
    resetRecordModal() {
      this.record = {type: 'credit'};
    },
    showAccounting(data) {
      console.log(data)
      this.accounting = data;
      this.$refs.accountingModal.show();
    },
    deleteAccountingAction(id) {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'İşlem kalıcı olarak silinecektir, emin misiniz?',
      }).then(ok => {
        if (ok.value) {
          this.deleteAccounting(id).then(res => {
            this.success(res.data.message);
            this.loadData();
          }).catch(error => {
            this.error(error.response.data.message);
          });
        }
      });
    },
    sendSMSModal() {
      this.smsText = '';
      this.$refs.sendSMSModal.show();
    },
    sendSMS() {
      this.sendSMSToClient({
        id: this.$route.params.id,
        message: this.smsText,
      }).then(res => {
        this.success(res.data.message);
        this.$refs.sendSMSModal.hide();
      }).catch(error => {
        this.error(error.response.data.message);
      });
    },
    paymentType(type) {
      switch (type) {
        case 'credit_cart':
          return 'Kredi Kartı';
        case 'eft':
          return 'Havale / EFT';
        case 'check':
          return 'Çek';
        case 'bill':
          return 'Senet';
        default:
          return 'Nakit';
      }
    },
    openContract(id) {
      window.open(`/sozlesme/${id}`, '_blank')
    },
    async showContract(id) {
      await this.getOrderContractById(id).then(res => {
        this.selectedContract = res.data.contract.contract
        this.selectedContractId = res.data.contract.id
      })
      this.$refs.contractModal.show()
    },
    async loadData() {
      this.loading = true;
      // console.log(this.getUser())
      await this.showClientDetails(this.$route.params.id).then(data => data.data).then(response => {
        this.bankAccounts = response.accounts;
        this.history = response.history;
        this.contracts = response.contracts;
        this.sumOfCredit = response.sum_of_credit;
        this.sumOfPay = response.subPays;
        this.subPaysDebt = response.subPaysDebt;
        this.monthlyDebt = response.monthlyDebt;
        this.sumOfDebt = response.sum_of_debt;
        this.checkBalance = response.check_balance;
        this.billBalance = response.bill_balance;
        this.total = response.total;
        this.expenseCategories = response.expense_categories;
        this.client = response.client;
        this.clientImages = response.images;
        const client = response.client;
        this.generalInfo[0].value = client.full_name
        this.generalInfo[1].value = client.gsm
        this.generalInfo[2].value = client.email
        // this.generalInfo[4].value = `${client.address} - ${client.county} / ${client.city}`
        this.generalInfo[3].value = client.company_name
        // this.generalInfo[5].value = client.website
        this.generalInfo[4].value = `${client.tax_office} / ${client.tax_no}`
        // this.generalInfo[7].value = client.balance
        // this.generalInfo[5].value = client.identity_number

        this.loading = false
      })

      this.getIncomeDependencies().then(data => data.data).then(response => {
        this.incomeCategories = response.categories;
      })
    },
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    this.loadData();
  }
}
</script>
